export const BMI_THRESHOLDS = {
  underweight: 18.5,
  normalUpper: 24.9,
  overweightUpper: 29.9,
  obesity: 30,
} as const;

export const WHTR_THRESHOLDS = {
  low: 0.4,
  normalUpper: 0.49,
  highUpper: 0.59,
  veryHigh: 0.6,
} as const;

export const NUTRITION_LABELS = {
  bmi: 'BMI',
  normalWeightRange: 'Range normopeso',
  deltaToNormalWeight: 'Scostamento dal normopeso',
  waistToHeightRatio: 'Waist-to-Height Ratio',
  waistToChestRatio: 'Waist-to-Chest Ratio',
  bodySurfaceArea: 'Body Surface Area',
  bodyFatPercentage: 'Body Fat % stimata',
  fatMassKg: 'Massa grassa stimata',
  leanMassKg: 'Massa magra stimata',
} as const;
